export default __webpack_public_path__ + "static/media/BackPressIcon.8c7f60d9.svg";